var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsIconRectenggle5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153751",
    "data-name": "\\uC0AC\\uAC01\\uD615 153751",
    width: 23,
    height: 24,
    transform: "translate(0 23) rotate(-90)",
    fill: "#ff7696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIconRectenggle5);
export default __webpack_public_path__ + "static/media/contact_us_icon_rectenggle5.f6f7a851666a8e9fcf207699367b90de.svg";
export { ForwardRef as ReactComponent };